module.exports = __webpack_public_path__ + "static/media/13.f09620e7.png";